module.exports = __webpack_public_path__ + "media/images/application/template/logos/logo-containers-a1cbf14bdaba847b5dc1f7e8bcd9583e.svg";